<template>
  <div class="tips">
    <parachuter ref="parachuter" person="woman" direction="left" />
    <img class="corner-fern" data-src="./assets/tips/tips-corner-fern.png">
    <split-container direction="up" top-brand-color="white" bottom-brand-color="green">
      <template v-slot:top>
        <div class="top-container">
          <div class="tips-text">
            <div class="breadcrumb">04&nbsp;&mdash;&nbsp;Tips &amp; Recipes</div>
            <div class="tips-intro">
              <stacked-headline
                class="stacked-headline"
                top-text="How to Eat"
                top-color="dark-green"
                bottom-text="Kiwi"
                bottom-color="yellow">
              </stacked-headline>
              <p>Whether it’s part of a healthy breakfast or a sweet little snack, eating Zespri SunGold Kiwifruit is easy! Just cut, scoop and enjoy.</p>
              <a href="/en-US/blogdetail/cut-slice-or-peel-the-many-ways-to-eat-and-enjoy-kiwifruit" target="_blank" class="learn-more-btn ">Learn more</a>
            </div>
          </div>
          <div class="tips-image-wrapper"><span class="tips-image"></span></div>
        </div>
      </template>
      <template v-slot:bottom>
        <div class="bottom-container">
          <div class="cooking-image">
            <img data-src="./assets/tips/cooking-with-zespri.png">
          </div>
          <div class="cooking-text">
            <h2>Cooking with Zespri</h2>
            <p>Add tropical flair to any recipe, sweet or savory, with Zespri SunGold Kiwifruit. Blend it in a smoothie. Use it as a marinade. Add a little sweetness to some salsa.</p>
            <p class="recipe-cta hide-for-launch">Check out our recipes for a fun kitchen adventure.</p>
            <button class="explore-btn hide-for-launch">Explore recipes</button>
          </div>
        </div>
      </template>
    </split-container>
  </div>
</template>

<script>
import SplitContainer from '../components/SplitContainer.vue'
import StackedHeadline from '../components/StackedHeadline.vue'
import Parachuter from '../components/Parachuter.vue'

export default{
  name: 'tips',
  components: {
    'split-container': SplitContainer,
    'stacked-headline': StackedHeadline,
    'parachuter': Parachuter
  },
  props: {
    active: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    active(active) {
      if (active) {
        this.$refs.parachuter.play()
      } else {
        this.$refs.parachuter.pause()
      }
    }
  },
}
</script>

<style unscoped lang="scss">
@import '../theme';

.tips {
  .bottom {
    z-index: zespri-layer(top-split);
    @include media-breakpoint-up(md) {
      max-height: 450px;
    }
  }
}

/* IE and Edge don't support animating background-image so use the gif */
.edge, .ie {
  .tips-image {
    background-image: url('../assets/tips/cut-scoop-enjoy-frames_1080x798.gif') !important;
  }
}
</style>

<style scoped lang="scss">
/** tips **/
@import '../theme';

.tips {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  /* Ensure the Parachuter doesn't cause horizontal scroll. */
  overflow-x: hidden;

  @include media-breakpoint-up(lg) {
    height: 1000px;
  }
}

.container{
  @include media-breakpoint-up(lg) {
    height: 1000px;
  }
}

.corner-fern {
  position: absolute;
  top: 0;
  right: 0;
  z-index: zespri-layer(overlay);
  width: 100px;

  @include media-breakpoint-up(md) {
    width: 20%;
  }
}

.top-container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: stretch;
  }
}

.tips-text {
  display: flex;
  flex-direction: column;
  padding: 32px;

  @include media-breakpoint-up(md) {
    width: 40%;
    padding: 2% 7vw 2% 7vw;
    justify-content: space-between;
  }

  .breadcrumb {
    @include zespri-tiny-title;
    color: zespri-brand-color(dark-green);
    margin-bottom: 50px;

    @include media-breakpoint-up(md) {
      margin-bottom: 0;
    }
  }

  .tips-intro {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    justify-content: center;

    @include media-breakpoint-up(md) {
      padding-left: 2vw;

      .stacked-headline {
        align-self: flex-start;
      }
    }

    .stacked-headline {
      align-self: center;

      @include media-breakpoint-up(md) {
        align-self: flex-start;
      }
    }
  }
}

@mixin make-cut-scoop-animation($size) {
  @keyframes cut-scoop-enjoy-#{$size} {
    0% {
      background-image: url('../assets/tips/frame-cut_#{$size}x#{$size}.jpg');
    }
    31% {
      background-image: url('../assets/tips/frame-cut_#{$size}x#{$size}.jpg');
    }
    33% {
      background-image: url('../assets/tips/frame-scoop_#{$size}x#{$size}.jpg');
    }
    65% {
      background-image: url('../assets/tips/frame-scoop_#{$size}x#{$size}.jpg');
    }
    66% {
      background-image: url('../assets/tips/frame-enjoy_#{$size}x#{$size}.jpg');
    }
    99% {
      background-image: url('../assets/tips/frame-enjoy_#{$size}x#{$size}.jpg');
    }
    100% {
      background-image: url('../assets/tips/frame-cut_#{$size}x#{$size}.jpg');
    }
  }
}

@include make-cut-scoop-animation(1080);
@include make-cut-scoop-animation(744);
// @include make-cut-scoop-animation(474);
// @include make-cut-scoop-animation(360);

.tips-image-wrapper {
  position: relative;
  width: 100%;
  height: 35vh;
  transform: scale(1.1);
  transform-origin: top;
  border-radius: 50% 50% 0 0 / 150px 150px 0 0;
  overflow: hidden;

  @include media-breakpoint-up(sm) {
    height: 45vh;
    min-height: 300px;
    border-radius: 50% 50% 0 0 / 50% 50% 0 0;
  }

  @include media-breakpoint-up(md) {
    transform: scale(1.5);
    transform-origin: left;
    width: 60%;
    height: auto;
    margin-top: 0;
    border-radius: 100px 0 0 100px / 50% 0 0 50%;
  }

  @include media-breakpoint-up(lg) {
    transform: scale(1.5);
    transform-origin: left;
    border-radius: 200px 0 0 200px / 50% 0 0 50%;
  }
}

.tips-image {
  @include absolute-fill;
  transform: scale(0.95);
  transform-origin: top;
  animation: cut-scoop-enjoy-744 5s linear infinite;
  background-image: url('../assets/tips/frame-cut_744x744.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom left;

  @include media-breakpoint-up(md) {
    transform: scale(0.8);
    transform-origin: left;
    animation: cut-scoop-enjoy-1080 5s linear infinite;
  }
}

.learn-more-btn {
  @include cta-button(zespri-brand-color(dark-green), zespri-brand-color(green));
}

.explore-btn {
  @include cta-button(zespri-brand-color(dark-green), $white);
}

.recipe-cta {
  @include zespri-mid-title;
  text-transform: uppercase;
  color: zespri-brand-color(white);
}

.photo-overlay-text {
  @include zespri-mid-callout;
  text-transform: uppercase;
  color: zespri-brand-color(white);

  .dark-text {
    color: zespri-brand-color(dark-green);
  }
}

.masked-photo {
  position: absolute;
  top: 100%;
  right: 0;
  height: 100%;

  @include media-breakpoint-up(md) {
    position: absolute;
    top: 0;
    right: -50%;
    width: 104vh;
  }

  @include media-breakpoint-up(lg) {
    right: -30%;
  }

  @include media-breakpoint-up(xl) {
    right: -10%;
  }

  .desktop-image {
    display: none;
    @include media-breakpoint-up(md) {
      display: block;
    }
  }

  .mobile-image {
    display: block;
    @include media-breakpoint-up(md) {
      display: none;
    }
  }

  img {
    width: 100%;
  }
}

.bottom-container {
  display: flex;
  flex-direction: column;
  padding: 32px 32px 64px 32px;


  @include media-breakpoint-up(md) {
    padding: 0px 7vw;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
  }

  @include media-breakpoint-up(lg) {
    padding: 0px 8% 0 8%;
  }

  .cooking-image {
    @include media-breakpoint-up(md) {
      width: 50%;
      display: flex;
      align-items: center;
      height: 100%;
    }

    img {
      width: 100%;
      @include media-breakpoint-up(md) {
        // transform: translateY(-25%);
        width: 90%;
      }
    }
  }

  .cooking-text {
    @include media-breakpoint-up(md) {
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
  }
}

</style>
